/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formvalidation_Estimatedticketsizemin_Max4Inputs */

const en_formvalidation_estimatedticketsizemin_max4 = /** @type {(inputs: Formvalidation_Estimatedticketsizemin_Max4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated ticket size min. must be less than or equal to estimated ticket size max.`)
};

/**
* | output |
* | --- |
* | "Estimated ticket size min. must be less than or equal to estimated ticket size max." |
*
* @param {Formvalidation_Estimatedticketsizemin_Max4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formvalidation_estimatedticketsizemin_max4 = /** @type {((inputs?: Formvalidation_Estimatedticketsizemin_Max4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formvalidation_Estimatedticketsizemin_Max4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formvalidation_estimatedticketsizemin_max4(inputs)
});
export { formvalidation_estimatedticketsizemin_max4 as "formValidation_estimatedTicketSizeMin_max" }